<template>
  <div class="section-background">
    <div class="container">
      <div
        v-if="loading"
        class="wrapper d-flex align-items-center"
      >
        <div>
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          />
        </div>
      </div>
      <div
        v-else
        class="hero"
      >
        <div class="image">
          <img
            src="../assets/img/marketplace-image.jpg"
            alt="marketplace-image"
          >
        </div>
        <div class="text">
          <h1>Just one step away from hiring {{ coach.user.firstname }}</h1>
          <p>Tell us a bit about yourself</p>
          <b-form @submit.prevent="() => {}">
            <div class="row">
              <div class="col-sm">
                <div class="form-group">
                  <b-form-input
                    v-model="form.email"
                    type="email"
                    :state="emailState"
                    aria-describedby="emailHelp"
                    placeholder="Email address*"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="form-group">
                  <b-form-input
                    v-model="form.firstname"
                    type="text"
                    :state="firstnameState"
                    aria-describedby="firstname"
                    placeholder="First name*"
                  />
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group">
                  <b-form-input
                    v-model="form.lastname"
                    type="text"
                    :state="lastnameState"
                    aria-describedby="lastname"
                    placeholder="Last name*"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <textarea
                id
                v-model="form.remark"
                class="form-control"
                rows="3"
                placeholder="What would you like to work on?"
              />
            </div>
            <hr>
            <div
              v-if="parseInt(form.num_sessions) === 1"
              class="row"
            >
              <div class="col-sm" />
              <div class="col-sm">
                <div class="form-group">
                  <b-form-input
                    id="discount-input"
                    v-model="form.discount_code"
                    type="text"
                    :state="discountState"
                    aria-describedby="discount-input discount-input-feedback"
                    placeholder="Discount code"
                  />
                  <b-form-invalid-feedback id="input-live-feedback">
                    Type in your 6-digit discount code.
                  </b-form-invalid-feedback>
                  <!-- This is a form text block (formerly known as help block) -->
                  <!-- <b-form-text id="input-live-help">
                    Type in your 6-digit discount code.
                  </b-form-text> -->
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group">
                  <button
                    class="login-button"
                    @click="discountCodeInput"
                  >
                    Apply discount
                  </button>
                </div>
              </div>
            </div>
            <div
              v-if="showAlert"
              :class="alertClass"
            >
              {{ alertMessage }}
            </div>
            <div class="buttons text-right">
              <div class="cta">
                <div
                  v-if="discount"
                  class="muted"
                >
                  <del>
                    <b>$ {{ coachFees }}</b></del>
                </div>
                <div
                  v-if="!discount"
                  class="price"
                >
                  <span><b>$</b> {{ coachFees }}</span>
                </div>
                <div
                  v-else
                  class="price"
                >
                  <span><b>$</b> {{ discountedFees }}</span>
                </div>
              </div>
              <b-button
                v-if="!loading"
                :disabled="!formValid"
                variant="primary"
                class="primary-button primary with-icon"
                @click="submit"
              >
                Proceed to Payment
              </b-button>
              <b-button
                v-else
                variant="primary"
                class="primary-button primary"
              >
                <b-spinner
                  small
                  type="grow"
                />
                Loading...
              </b-button>
            </div>
          </b-form>
        </div>

        <div class="visual">
          <div class="background">
            <img
              src="../assets/img/hero-background.svg"
              alt="background visual"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section-background padding-xl pt-0 pb-0 auto-height">
      <div class="container">
        <b-carousel
          id="carousel-2"
          :interval="5000"
          indicators
        >
          <b-carousel-slide>
            <template v-slot:img>
              <div class="review">
                <div class="quote">
                  <p>
                    <!-- It is a really easy app to use. Find a way to record a video, upload to Ludimos, get really detailed feedback that helps you progress your game.  -->
                    <!-- <br> -->
                    I was not aligned and had an angled bat when I started using
                    Ludimos. Dave helped me to straighten up and become a solid
                    batsman. I highly recommend using Ludimos to get your game
                    to the next level.
                  </p>
                </div>
                <div class="avatar">
                  <img
                    src="../assets/img/user1.jpg"
                    alt=""
                  >
                  <div class="name">
                    Ashton Charles
                    <span>United Kingdom</span>
                  </div>
                </div>
              </div>
              <div class="review">
                <div class="quote">
                  <p>
                    Ludimos is a well set out app that allows me to go back and
                    have a look at the uploaded videos and see what I need to
                    work on and what I did well, and works effectively.

                    <!-- It also
                    allows the other team members to see what everyone is
                    working on and in that way give some feedback to each other. -->
                  </p>
                </div>
                <div class="avatar">
                  <img
                    src="../assets/img/user4.jpg"
                    alt=""
                  >
                  <div class="name">
                    Eliz-Mari Marx
                    <span>South Africa</span>
                  </div>
                </div>
              </div>
            </template>
          </b-carousel-slide>
          <b-carousel-slide>
            <template v-slot:img>
              <div class="review">
                <div class="quote">
                  <p>
                    I am an opening bowler who bats at 11. Now because of ludimos I
                    am batting at 6, make 30+ runs and secure the win for my
                    team. I highly recommend using Ludimos because you can
                    improve more than you think!
                  </p>
                </div>
                <div class="avatar">
                  <img
                    src="../assets/img/user2.jpg"
                    alt=""
                  >
                  <div class="name">
                    Noah de Roos
                    <span>The Netherlands</span>
                  </div>
                </div>
              </div>
              <div class="review">
                <div class="quote">
                  <p>
                    Uploading the video was easy and without hassles. Due to
                    there being no cricket season this year and no matches, I
                    have not been able to put in any stats yet. I have played
                    around on the system and excited to use it further.
                  </p>
                </div>
                <div class="avatar">
                  <img
                    src="../assets/img/user3.jpg"
                    alt=""
                  >
                  <div class="name">
                    Nathan du Plooy
                    <span>South Africa</span>
                  </div>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>
    <div class="section-background padding-xl pt-0 pb-0 auto-height">
      <div class="container">
        <div class="row usp-row">
          <div class="col-md-4">
            <div class="usp-holder">
              <i class="material-icons">sports_cricket</i>
              <p>Coaches You Can Trust</p>
              <span>All of our coaches have extensive coaching experience and are
                ICC, ECB, AUS, SA or BCCI certified coaches.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="usp-holder">
              <i class="material-icons">account_balance_wallet</i>

              <p>Easy Booking & Payment</p>
              <span>Every coaching session can be booked in minutes through Ludimos
                and all financial transactions are securely processed
                online</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="usp-holder">
              <i class="material-icons">admin_panel_settings</i>

              <p>
                Good-Fit Guarantee
              </p>
              <span>We are committed to helping you find the right coach. Our
                coaches are world class and well qualififed to assit you to take
                you to the next level.
              </span>
            </div>
          </div>
        </div>
        <div
          id="howItWorks"
          class="section-background auto-height"
        >
          <HowItWorks />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CoachingService from "@/services/coachingService";
import CoachService from "@/services/coaches";
import HowItWorks from "./HowItWorks.vue";
export default {
  name: "CoachingRequest",
  components: {
    HowItWorks,
  },
  data() {
    return {
      loading: false,
      pk: process.env.VUE_APP_STRIPE_PK,
      discount: false,
      coach: { user: {} },
      showAlert: false,
      alertMessage: "failed",
      alertClass: "alert alert-success",
      form: {
        email: "",
        firstname: "",
        lastname: "",
        skill: "BOTH",
        interval: "ONCE",
        remark: "",
        success_url: `${window.location.origin}/payment_successful`,
        cancel_url: `${window.location.href}`,
        discount_code: "",
        num_sessions: 1,
      },
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.discount = false;
    this.coach = { user: {} };
    this.form.num_sessions = this.$route.query.num_sessions
      ? parseInt(this.$route.query.num_sessions)
      : 1;
    next();
  },
  computed: {
    firstnameState() {
      return !this.form.firstname.length
        ? null
        : this.form.firstname.length > 1
        ? true
        : false;
    },
    lastnameState() {
      return !this.form.lastname.length
        ? null
        : this.form.lastname.length > 1
        ? true
        : false;
    },
    emailState() {
      return !this.form.email ? null : this.validEmail(this.form.email);
    },
    discountState() {
      return (
        this.form.discount_code.length && this.form.discount_code.length === 6
      );
    },
    coachFees() {
      let fees = this.coach.fees ? this.coach.fees / 4 : 0;

      if (parseInt(this.form.num_sessions) === 3) {
        fees = this.form.num_sessions * fees * 0.9;
      }

      if (parseInt(this.form.num_sessions) === 5) {
        fees = this.form.num_sessions * fees * 0.85;
      }

      return fees ? `${fees.toFixed(2)}` : `Not Available`;
    },
    discountedFees() {
      const fees = this.coach.fees
        ? (this.coach.fees / 4) * (1 - this.discount / 100.0)
        : 0;
      return fees ? `${fees.toFixed(2)}` : `Not Available`;
    },
    formValid() {
      if (
        !this.form.firstname ||
        !this.form.lastname ||
        !this.validEmail(this.form.email)
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Coach_Hire",
      action: "Request",
      label: `${this.$route.params.id}`,
      type: `${this.$route.params.id}`,
    });

    if (this.$route.query && this.$route.query.discount_code) {
      this.form.discount_code = this.$route.query.discount_code.toUpperCase();
      this.discountCodeInput();
    }
  },
  created() {
    this.form.num_sessions = this.$route.query.num_sessions
      ? parseInt(this.$route.query.num_sessions)
      : 1;
    this.loadData();
  },
  methods: {
    hideAlert(secs) {
      setTimeout(() => {
        this.showAlert = false;
      }, secs);
    },
    async discountCodeInput() {
      if (
        this.form.discount_code.length &&
        this.form.discount_code.length === 6
      ) {
        try {
          const response = await CoachingService.validateDiscountCoe(
            this.$route.params.id,
            this.form.discount_code.toUpperCase()
          );
          this.discount = response.data.discount;
          this.alertMessage = `${this.discount}% discount applied!`;
          this.alertClass = "alert alert-success";
          this.showAlert = true;
          this.hideAlert(5000);
        } catch (error) {
          this.discount = false;
          this.alertMessage = error.message;
          this.alertClass = "alert alert-error";
          this.showAlert = true;
          this.hideAlert(2000);
        }
      } else {
        this.discount = false;
      }
    },
    async loadData() {
      this.loading = true;
      const response = await CoachService.getCoach(
        this.$route.params.id,
        Object.assign(
          {
            _related: "user",
          },
          this.$route.query
        )
      );
      if (!response.data || response.data.status !== "APPROVED") {
        this.$router.push({ name: "error" });
        return;
      }
      this.coach = response.data ? response.data : this.coach;
      this.loading = false;
    },
    submit() {
      if (this.formValid) {
        this.loading = true;
        this.form.coach_profile_id = parseInt(this.$route.params.id);
        this.form.url_params = this.$route.query;
        if (this.form.discount_code) {
          this.form.discount_code = this.form.discount_code.toUpperCase();
        }
        CoachingService.createRequest(this.form)
          .then((response) => {
            if (response.status === 201) {
              this.successful = true;

              // Tracking code
              this.$ma.trackEvent({
                fb_event: "InitiateCheckout",
                category: "InitiateCheckout",
                action: "InitiateCheckout",
                label: `${this.$route.params.id}`,
                type: `${this.$route.params.id}`,
                value: this.coachFees,
              });
              // redirect to stripe page for payment
              let stripe = window.Stripe(this.pk);
              stripe.redirectToCheckout({
                sessionId: response.data.session_id,
              });
              // this.loading = false;
            }
          })
          .catch(() => {
            this.successful = false;
            this.$bvToast.toast("Request failed. Please try again!", {
              title: "Request failure",
              variant: "danger",
              solid: true,
              toaster: "b-toaster-top-center",
              autoHideDelay: "3000",
            });
          });
      }
    },
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Hire coach`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style lang="scss" scoped>
.review {
  margin: 50px 0;
  padding: 0 15px;
  display: inline-block;
  width: 50%;
  img {
    border-radius: 40px;
    height: 70px;
    margin-right: 15px;
  }
  .avatar {
    display: flex;
    align-items: center;
    .name {
      font-weight: bold;
      span {
        display: block;
        opacity: 0.7;
        font-weight: normal;
      }
    }
  }
  .quote {
    margin: 0 0 20px;
    font-size: 14px;
    line-height: 1;

    &:before {
      content: "format_quote";
      font-family: "Material Icons";
      position: relative;
      font-size: 60px;
      bottom: -20px;
      opacity: 0.5;
    }
    p {
      display: inline;
    }
  }
}
.hero .text {
  width: 50%;
}
.usp-row {
  text-align: center;
  margin: 100px 0 0;
  .usp-holder {
    border-radius: 10px;
    padding: 20px;
    background: #fff;
    background: linear-gradient(0deg, #e0d6ff 0%, #eee8ff 100%);
    color: #2b3060;
  }
  i {
    font-size: 100px;
    color: #6f44ff;
  }

  p {
    font-weight: bold;
    font-size: 20px;
  }
  span {
    font-size: 14px;
  }
}

.section-background {
  min-height: 0;
}

.hero {
  display: flex;
  min-height: 0;
}

.image {
  width: 50%;
  margin-right: 40px;

  img {
    max-width: 100%;
    height: auto;
    max-height: 100%;
    border-radius: 4px;
  }
}

.buttons {
  margin: 30px 0;
}

.contact-block {
  text-align: center;

  p {
    margin: 0;
  }
  i {
    font-size: 50px;
    color: #fff;
    margin: 30px 0;
    background: #6f44ff;
    padding: 20px;
    border-radius: 5px;
  }
  a {
    display: block;
  }
}
.contact-map {
  iframe {
    background: #fff;
    padding: 5px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
  }
}

.price {
  color: #00c088;
  font-size: 40px;
  font-weight: 600;
  margin: 0 0 15px;

  b {
    font-size: 20px;
    font-weight: 600;
  }

  span {
    display: block;
    line-height: 1;

    &:nth-child(2) {
      font-size: 14px;
      font-weight: normal;
    }
  }
}
.login-button {
  background: none;
  color: rgba($color: #2b3060, $alpha: 0.7);
  border-radius: 4px;
  padding: 0 14px;
  font-size: 15px;
  height: 40px;
  font-weight: bold;
  outline: none;
  transition: all 0.3s ease-in-out;
  border: 2px solid rgba(43, 48, 96, 0.3);
  &:hover {
    border: 2px solid #6f44ff;
    color: #fff;
    background: #6f44ff;
  }
}

@media (max-width: 767px) {
  .hero {
    display: block;
    .image {
      width: 100%;
    }
    .text {
      width: 100%;
      margin: 20px 0 0;
    }
  }
  .usp-holder {
    margin: 0 0 20px;
    span {
      display: none;
    }
  }
  .review {
    width: 100%;
    margin: 0;
  }
}
</style>
